import React from 'react'
import './Wcdw.css'
import cep from '../../../../assets/img/cep.svg'
import hd from '../../../../assets/img/hd.svg'
import auor from '../../../../assets/img/auor.svg'
import nti from '../../../../assets/img/nti.svg'
import ct from '../../../../assets/img/ct.svg'
import pds from '../../../../assets/img/pds.svg'
import cefimg from '../../../../assets/img/cef.webp'

function Wcdw() {
    const wcdwlist= [
        {
            id: 0, 
            icon:cep, 
            title:"Cost-Effective Process", 
            desc:"At 360 Bytes, our web app development services are designed to be cost-effective, ensuring your project is executed efficiently without compromising on quality. We optimize our processes to deliver high-quality solutions within your budget.",
            img:cefimg
        },
        {
            id: 1, 
            icon:auor, 
            title:"All Under One Roof", 
            desc:"As a one-stop web application development company, 360 Bytes offers a comprehensive range of services, from concept to deployment. Our integrated approach ensures that all your web development needs are met under one roof, providing convenience and consistency."
        },
        {
            id: 2, 
            icon:ct, 
            title:"Creative Team", 
            desc:"Our creative team of web app developers at 360 Bytes is dedicated to turning your vision into innovative web solutions. We infuse creativity into every aspect of your project, ensuring that the final product stands out in the market."
        },
        {
            id: 3, 
            icon:hd, 
            title:"24/7 Help Desk", 
            desc:"With a commitment to customer satisfaction, 360 Bytes offers a 24/7 help desk. Our support team is always available to assist you, ensuring a seamless development experience and prompt resolution of any issues."
        },
        {
            id: 4, 
            icon:nti, 
            title:"New Technology Integration", 
            desc:"Staying at the forefront of technology, 360 Bytes integrates the latest advancements into your web applications. Our commitment to innovation ensures that your web apps remain cutting-edge and competitive in the ever-evolving digital landscape."
        },
        {
            id: 5, 
            icon:pds, 
            title:"Post-Deployment Services", 
            desc:"Our web development services extend beyond the launch phase. 360 Bytes provides ongoing post-deployment services, including regular updates, maintenance, and support, to ensure the continued success and optimal performance of your web application."
        },
    ]

  return (
    <section className='wcdw-sec'>
        <div className='container'>
            <h3>Why Choose Us To Develop Your Website?</h3>
            <ul>
                {
                    wcdwlist.map((Wcdw, index)=>(
                        <li>
                        <h4><span className='wgbs-icon'><img src={Wcdw.icon} alt={Wcdw.title} width={64} height={64}/></span> <span className='wgbs-head'>{Wcdw.title}</span></h4> 
                        <p>{Wcdw.desc}</p>
                        {/*<div className='wcdw-img'><img src={Wcdw.img} alt=''/></div> */}  
                      </li>
                    ))
                }
                 
            </ul> 
        </div>

      </section>
  )
}

export default Wcdw
